import { Controller } from "@hotwired/stimulus";

const STORAGE_KEY = "sidebarCollapsed";
const MOBILE_MQ = "(min-width: 768px)";
const TOGGLE_ID = "console-sidebar-toggle";

export default class extends Controller {
  static values = { collapsed: Boolean };

  connect() {
    this._desktop = window.matchMedia(MOBILE_MQ);
    this._onResize = this._handleResize.bind(this);

    if (
      this._desktop.matches &&
      window.localStorage.getItem(STORAGE_KEY) === "true"
    ) {
      this.collapsedValue = true;
      this.element.dataset.collapsed = "true";
    }

    this._desktop.addEventListener("change", this._onResize);
  }

  disconnect() {
    this._desktop.removeEventListener("change", this._onResize);
  }

  toggle() {
    if (this._desktop.matches) {
      this.collapsedValue = !this.collapsedValue;
      this.element.dataset.collapsed = this.collapsedValue ? "true" : "false";
      window.localStorage.setItem(STORAGE_KEY, String(this.collapsedValue));
    } else {
      const input = document.getElementById(TOGGLE_ID);
      if (input) input.checked = false;
    }
  }

  _handleResize(event) {
    if (event.matches) {
      const stored = window.localStorage.getItem(STORAGE_KEY) === "true";
      this.collapsedValue = stored;
      this.element.dataset.collapsed = stored ? "true" : "false";
    } else {
      this.element.dataset.collapsed = "false";
    }
  }
}
